module.exports = __webpack_public_path__ + "static/img/shouye.b3cb2094.png";